'use strict';

const ProfileCtrl = function ($rootScope, $scope, CRUDService, Notification, config) {
  var ctrl = this;

  ctrl.changePw = function (form) {
    if (form.$valid) {
      CRUDService.save(
        {
          "username": $rootScope.user.uuid,
          "password": ctrl.passwords.new,
          "current": true
        },
        config.urls.users + '/changePw'
      ).then(function () {
        ctrl.passwords = {};
        form.$submitted = false;
        Notification.success("Ihr Passwort wurde erfolgreich geändert.");
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  ctrl.getRoles = function () {
    let ret = "";
    console.log($rootScope.user.roles);
    console.log($scope.roles);
    for (let urole in $rootScope.user.roles) {
      for (let role in $scope.roles) {
        if ($rootScope.user.roles[urole] === $scope.roles[role].id) {
          if (ret.length > 1) {
            ret += ", ";
          }
          ret += $scope.roles[role].label;
        }
      }
    }
    return ret;
  }

  $scope.roles = [
    { id: 'ROLE_ASSISTENT', label: 'Assistent' },
    { id: 'ROLE_OFFICER', label: 'Studienbeauftragter' },
    { id: 'ROLE_MONITOR', label: 'Monitor' },
    { id: 'ROLE_ADMIN', label: 'Administrator' },
    { id: 'ROLE_CUSTODIAN', label: 'Datentreuhänder' }
  ];

  $scope.userRoles = ctrl.getRoles();

};



ProfileCtrl.$inject = ['$rootScope', '$scope', 'CRUDService', 'Notification', 'config'];

module.exports = {
  template: require('./profile.html'),
  controller: ProfileCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/settings-profile/profile.component.js